import { useContext } from 'react';
import { ArrowCounterClockwise } from '@phosphor-icons/react';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { SVG_SIZE_M } from 'src/constants';
import { useDeleteAttachment } from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { Message } from 'src/types';
import ForwardRefContext from 'src/contexts/ForwardRefContext';

interface RephraseMessageButtonProps {
  originalQuery: Message['original_query'];

  disabled?: boolean;
}

export const RephraseMessageButton = ({
  originalQuery,
  disabled,
}: RephraseMessageButtonProps) => {
  const { threadInputBoxRef } = useContext(ForwardRefContext);
  const { setThreadInputBoxValue } = useContext(ThreadInputBoxContext);
  const { onDeleteAllAttachments } = useDeleteAttachment();

  const handleClick = () => {
    setThreadInputBoxValue(originalQuery || '');
    onDeleteAllAttachments();
    threadInputBoxRef?.current?.focus();
  };

  return (
    <Button
      color="transparent"
      disabled={!originalQuery || disabled}
      onClick={handleClick}
      data-e2e="rephrase-button"
      tooltipContent="Rephrase"
      tooltipPlace="left"
    >
      <ArrowCounterClockwise size={SVG_SIZE_M} />
    </Button>
  );
};
